"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _default = _react.default.createContext({
  numItems: 0,
  scrollBarPercentage: '0%',
  scrollBarWidth: '0%',
  scrolling: false,
  scrollOneLeft: function scrollOneLeft() {
    return 0;
  },
  scrollOneRight: function scrollOneRight() {
    return 0;
  },
  scrollTo: function scrollTo() {
    return 0;
  }
});

exports.default = _default;